<template>
  <div>
    <v-card>
      <v-card-title>Acompanhamento</v-card-title>
      <proposta-expandida-acompanhamento
        class="card-height"
        :followups="acompanhamento"
      />

      <v-flex class="md3 offset-md9 sm12">
        <button
          class="jns-button yellow-button"
          @click="dialogQuestionamento = true"
        >
          Questionamento
        </button>
      </v-flex>
    </v-card>

    <!-- Modal Questionamento -->
    <questionamento-component
      :questionamentoDialog="dialogQuestionamento"
      :questionamentoSucessoDialog="questionamentoSucessoModal"
      @send="sendQuestionamento"
      @close="dialogQuestionamento = false"
    />

    <v-dialog v-model="errorModal" :max-width="'640'">
      <base-modal>
        <h2 class="title" v-html="error.title"></h2>
        <p class="description" v-html="error.message"></p>
        <v-layout row wrap>
          <v-flex xs4 offset-xs8 mr-3>
            <button
              class="button jns-button yellow-button"
              @click="errorModal = false"
            >
              OK
            </button>
          </v-flex>
        </v-layout>
      </base-modal>
    </v-dialog>
  </div>
</template>

<script lang="js">
import ViewMixin from "@/mixins/ViewMixin";
import { mapActions } from "vuex";

export default {
  name: "TomadorAcompanhamento",
  mixins: [ViewMixin],
  props: ["acompanhamento", "idTomador"],
  data() {
    return {
      error: {},
      dialogQuestionamento: false,
      questionamentoSucessoModal: false,
      errorModal: false,
    };
  },
  methods: {
    ...mapActions(["POST_TOMADOR_QUESTIONAMENTO"]),

    async sendQuestionamento(data) {
      if (data == "") {
        this.errorModal = true;
        this.error.title = "Aviso";
        this.error.message = "Favor informar uma observação.";
        this.hideLoadingAskWait();
        return;
      }

      let questionamentoSucesso = false;

      try {
        this.showLoadingAskWait();
        await this.POST_TOMADOR_QUESTIONAMENTO({
          observacoes: data || "",
          idTomador: this.idTomador,
        });
        questionamentoSucesso = true;
      } catch (e) {
        this.defaultHandlerError(e);
      } finally {
        this.hideLoadingAskWait();
      }

      if (questionamentoSucesso) {
        this.dialogQuestionamento = false;
        this.questionamentoSucessoModal = true;
      }
    },
  },
};
</script>

<style lang="css" scoped>
.v-card__title {
  background-color: #efefef;
  font-size: 14px;
  font-weight: bolder;
  color: #191737;
  margin-bottom: 20px;
}

.card-height {
  max-height: 52vh !important;
  overflow: auto;
}
</style>


// WEBPACK FOOTER //
// ./src/components/TomadorAcompanhamento.vue